import style from './ContactPersonList.module.scss';

import { ContactPersonCard } from './ContactPersonCard';

export interface ContactPersonListParams {}

interface Props extends ContactPersonListParams {
    contactPersonIds: string[];
    onUpdateContactPerson(): void;
}

export function ContactPersonList({ contactPersonIds = [], onUpdateContactPerson }: Props) {
    return (
        <div className={style.root}>
            {contactPersonIds.map(id => (
                <div
                    className={style.CardWrapper}
                    key={id}
                >
                    <ContactPersonCard
                        id={id}
                        onUpdateContactPerson={onUpdateContactPerson}
                    />
                </div>
            ))}
        </div>
    );
}
